module.exports = __webpack_public_path__ + "static/media/bandCircum.60bcf2df.png";